module Meevo.Plugins.Services {
    "use strict";

    /**
    * Compensation Section of Service 
    */
    export class CompensationSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ServiceCompensation> {

        public modalService: Components.Modal.IModalService;

        
       
        constructor(sectionId: number, displayNameContentKey: string, template: string, isPrimarySection: boolean,
            handlesOwnCrud: boolean, baseEndpoint: string, sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            noun: Meevo.Model.NounEnum,
            modalService: Components.Modal.IModalService,
            sectionSecurityKey?: string) {

            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun,null,sectionSecurityKey);
            this.modalService = modalService;
            this.dataService = dataService;

        }

        compensationEmployeeList(serviceId: any, type: any): angular.IPromise<any> {
            
            let request = {
                pageNumber: 0,
                itemsPerPage: 10000,
                sortDirection: Model.SortDirection.Ascending,
                criteria: {
                    isShopCostDeduction:        type == '30041' ? true : false,
                    isLaborCostDeduction:       type == '30042'? true : false,
                    isNewClientDeduction:       type == '30043'? true : false,
                    overrideStandardService:    type == '30044'? true : false
                }
            };
            return this.dataService.getListPaged('Service/' + serviceId + '/CompensationEmployee', request)
                .then(response => {
                    return  response;
                });
          }
        
        getCompensationEmployeeList(serviceId: any, type: any, isReadonly: boolean): void {
            var listEmployees: any; 
            switch (type) {
                case '30041':
                    if (this.model.employeeOverrideListShopCosts != undefined && this.model.employeeOverrideListShopCosts.length > 0)
                    {
                        listEmployees = this.model.employeeOverrideListShopCosts;
                        this.showOverrideModal(listEmployees, type, isReadonly);
                    }else
                    {
                        this.compensationEmployeeList(serviceId, type).then((item: any) => {
                           this.model.employeeOverrideListShopCosts = item;
                           listEmployees = this.model.employeeOverrideListShopCosts;
                           this.showOverrideModal(listEmployees, type, isReadonly);
                       });
                     }
                    break;

                case '30042':
                    if (this.model.employeeOverrideListLaborCosts != undefined && this.model.employeeOverrideListLaborCosts.length > 0) {
                        listEmployees = this.model.employeeOverrideListLaborCosts;
                        this.showOverrideModal(listEmployees, type, isReadonly);
                    } else {
                        this.compensationEmployeeList(serviceId, type).then((item: any) => {
                            this.model.employeeOverrideListLaborCosts = item;
                            listEmployees = this.model.employeeOverrideListLaborCosts;            
                            this.showOverrideModal(listEmployees, type, isReadonly);
                        });
                    }
                   break;

                case '30043':
                    if (this.model.employeeOverrideListFirstTime != undefined && this.model.employeeOverrideListFirstTime.length > 0) {
                        listEmployees = this.model.employeeOverrideListFirstTime;
                        this.showOverrideModal(listEmployees, type, isReadonly);
                    } else {
                        this.compensationEmployeeList(serviceId, type).then((item: any) => {
                            this.model.employeeOverrideListFirstTime = item;
                            listEmployees = this.model.employeeOverrideListFirstTime;
                            this.showOverrideModal(listEmployees, type, isReadonly);
                        });
                    }
                    break;

                case '30044':
                    if (this.model.employeeOverrideListCommissionOverride != undefined && this.model.employeeOverrideListCommissionOverride.length > 0) {
                        listEmployees = this.model.employeeOverrideListCommissionOverride;
                        this.showOverrideModal(listEmployees, type, isReadonly);
                    } else {
                        this.compensationEmployeeList(serviceId, type).then((item: any) => {
                            this.model.employeeOverrideListCommissionOverride = item;
                            listEmployees = this.model.employeeOverrideListCommissionOverride;
                            this.showOverrideModal(listEmployees, type, isReadonly); 
                        });
                    }
                    break;
                }
            
         
        }

        showOverrideModal(listEmployees:any,type:any, isReadonly:boolean) {
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/services/sectionViews/compensationEmployeesModal.html',
                clickOutsideToClose: true,
                locals: {
                    title: "LABEL_SERVICE_COMMISSION_" + type,
                    employees: listEmployees,
                    model: this.model,
                    compensationType: type,
                    isReadonly: isReadonly
                },
                controller: 'meevo.plugins.services.CompensationEmployeesModalController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        }

        preSave() {
            if (this.model.employeeServiceCompensationRates == undefined) {
                this.model.employeeServiceCompensationRates = [];
            } 


            this.model.employeeServiceCompensationRates = _.union(this.model.employeeOverrideListCommissionOverride,
                this.model.employeeOverrideListLaborCosts, this.model.employeeOverrideListFirstTime, this.model.employeeOverrideListShopCosts);
            this.clearEmptyItem();
            super.preSave();
        }

        clearEmptyItem() {
            var newList: Model.EmployeeServoceOverride[]=[];
            _.forEach(this.model.employeeServiceCompensationRates , function (item) {
                if (item.employeeId.length > 0)
                    newList.push(item);
            });
            this.model.employeeServiceCompensationRates = newList;
        }


    }
}
